import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { ArrowLeft, Lightning } from "@phosphor-icons/react";

export default function MyOrders() {
  const { user, logout, loading } = useAuth();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (loading) return;
    if (!user) { nav("/login"); return; }
    api.get("/orders/my").then((r) => setOrders(r.data));
  }, [user, loading, nav]);

  return (
    <div className="min-h-screen bg-[#F9F9F9] pb-12">
      <header className="sticky top-0 z-40 glass border-b border-gray-100 px-4 py-3 flex items-center gap-2">
        <Link to="/home" className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center" data-testid="myorders-back"><ArrowLeft size={18} /></Link>
        <div className="flex-1">
          <div className="font-heading font-black">My orders</div>
          <div className="text-xs text-gray-500">{user?.mobile}</div>
        </div>
        <button onClick={() => { logout(); nav("/"); }} className="text-sm text-red-500 font-semibold" data-testid="myorders-logout">Logout</button>
      </header>

      <div className="max-w-2xl mx-auto p-4 space-y-3">
        <Link to="/account/addresses"
          className="qd-card p-3 flex items-center justify-between hover:bg-gray-50 transition"
          data-testid="myorders-addresses-link">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-[#F8CB46]/30 flex items-center justify-center">
              <span className="font-heading font-black text-[#15803D]">📍</span>
            </div>
            <div>
              <div className="font-heading font-black text-sm">My addresses</div>
              <div className="text-[10px] text-gray-500">Manage saved delivery addresses</div>
            </div>
          </div>
          <div className="text-[#15803D] font-bold text-sm">→</div>
        </Link>

        {orders.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            <div className="text-5xl mb-2">📦</div>
            No orders yet.<br />
            <Link to="/home" className="text-[#15803D] font-semibold underline">Browse marketplace</Link>
          </div>
        ) : orders.map((o) => (
          <div key={o.id} className="qd-card p-4" data-testid={`myorder-${o.order_number}`}>
            <div className="flex justify-between items-start">
              <div>
                <div className="font-mono text-xs text-gray-500">{o.order_number}</div>
                <div className="font-heading font-black text-lg mt-1">₹{o.total}</div>
                <div className="text-xs text-gray-500">{o.items.length} items · {o.payment_mode.toUpperCase()}</div>
              </div>
              <div className="text-right">
                <span className="text-xs px-2 py-1 rounded-full bg-gray-100 capitalize font-bold">{o.status.replace(/_/g, " ")}</span>
                <div className="text-xs text-gray-500 mt-1 flex items-center gap-1 justify-end">
                  <Lightning size={10} weight="fill" className="text-[#15803D]" /> {o.eta_minutes} min
                </div>
              </div>
            </div>
            <div className="mt-2 text-xs text-gray-600">
              {o.items.slice(0, 2).map((i) => i.name).join(", ")}
              {o.items.length > 2 && ` +${o.items.length - 2} more`}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
